import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class DescriptionHintVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationDescriptionhintCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationDescriptionhintCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationDescriptionhintReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationDescriptionhintRead,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationDescriptionhintDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationDescriptionhintDelete,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationDescriptionhintUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationDescriptionhintUpdate,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationDescriptionhintCreateany,
        PermissionAttributesEnum.GlobalOperationDescriptionhintUpdateany,
        PermissionAttributesEnum.GlobalOperationDescriptionhintDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationDescriptionhintCreate,
        PermissionAttributesEnum.ContextOperationDescriptionhintUpdate,
        PermissionAttributesEnum.ContextOperationDescriptionhintDelete,
      ],
    });
  };
}
